// extracted by mini-css-extract-plugin
export var modal = "_5n-0";